import IllinoisHeroSection from "./components/HeroSection";
import IllinoisCitiesDirectory from "./components/CitiesDirectory";
import IllinoisCommunitiesWeServe from "./components/CommunitiesWeServe";
import IllinoisStateResources from "./components/StateResources";
import IllinoisFAQSection, { faqs } from "./components/FAQSection";
import IllinoisFinalCTA from "./components/FinalCTA";
import CitySEOHead from "@/components/feature/CitySEOHead";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const faqsMapped = faqs.map((f: { question: string; answer: string }) => ({ q: f.question, a: f.answer }));

const servicesSchema = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function IllinoisPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Illinois"
        state="Illinois"
        stateAbbr="IL"
        route="/states/illinois"
        title="Illinois Passport Services — Expedited & Emergency | Fast Passport Center"
        description="Expedited passport services across Illinois — Chicago, Springfield, Peoria, Champaign, Rockford. Emergency processing as fast as 24 hours. A+ BBB rated courier service."
        geoPlacename="Illinois, United States"
        geoPosition="40.6331;-89.3985"
        faqs={faqsMapped}
        servicesSchema={servicesSchema}
        areaServedList={[{ "@type": "State", name: "Illinois" }]}
        serviceAreaDesc="Fast Passport Center serves Illinois travelers with expedited and emergency passport processing. Headquarters in Washington, DC with remote service across all Illinois cities."
      />
      <IllinoisHeroSection />
      <IllinoisCitiesDirectory />
      <IllinoisCommunitiesWeServe />
      <IllinoisStateResources />
      <IllinoisFAQSection />
      <SEOCrossLinks state="IL" />
      <IllinoisFinalCTA />
    </div>
  );
}